import React, { useState, useEffect } from "react";

import "./styles.scss";
import { IService } from "app/api/types";

interface IProps {
  onSubmit: (data: IService) => void;
  onSuccessChange: (active: boolean) => void;
  isSubmit: boolean;
}

const AddService: React.FC<IProps> = ({
  onSubmit,
  onSuccessChange,
  isSubmit
}) => {
  const [title, setTitle] = useState("");
  const [duration] = useState(1);
  const [price, setPrice] = useState(1);
  const [description, setDescription] = useState("");

  const onChange = (e: any) => {
    e.target.name === "title" && setTitle(e.target.value);
    // e.target.name === "duration" && setPosition(e.target.value);
    e.target.name === "price" && setPrice(e.target.value);
    e.target.name === "description" && setDescription(e.target.value);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    onSubmit({
      title,
      duration,
      price,
      description,
      categoryId: "1",
      href: "service"
    });
  };

  const getHeight = () => {
    let height = 50;
    if (title.length > 1) height += 47;
    // if (duration > 1) height += 47;
    if (price > 1) height += 47;
    if (description.length > 1) height += 20;

    return height;
  };

  useEffect(() => {
    if (
      title.length > 1 &&
      price > 1 &&
      // duration > 1 &&
      // duration % 30 === 0 &&
      description.length > 1
    )
      onSuccessChange(true);
    else onSuccessChange(false);

    isSubmit &&
      onSubmit({
        title,
        duration: 30,
        price,
        description,
        categoryId: "1",
        href: "service"
      });
  }, [
    title,
    duration,
    price,
    description,
    onSuccessChange,
    onSubmit,
    isSubmit
  ]);

  // const errorStyle = duration % 30 === 0 ? "" : "add-phrase__input_error";

  return (
    <div className="add-phrase" style={{ height: `${getHeight()}px` }}>
      <form className="add-phrase__form" onSubmit={handleSubmit}>
        <input
          className="add-phrase__input"
          onChange={onChange}
          value={title}
          name="title"
          placeholder="Название"
          autoComplete="off"
          required
        />
        {/* {title.length > 1 && (
          <input
            className={`add-phrase__input ${errorStyle}`}
            onChange={onChange}
            value={duration === 1 ? "" : duration}
            name="duration"
            placeholder="продолжительность в мин (кратная 30)"
            autoComplete="off"
            required
          />
        )} */}

        {/* {title.length > 1 && duration > 1 && ( */}
        {title.length > 1 && (
          <input
            className={`add-phrase__input`}
            onChange={onChange}
            value={price === 1 ? "" : price}
            name="price"
            placeholder="цена в руб."
            autoComplete="off"
            required
          />
        )}

        {title.length > 1 && (
          <input
            className={`add-phrase__input`}
            onChange={onChange}
            value={description}
            name="description"
            placeholder="описание услуги"
            autoComplete="off"
            required
          />
        )}
      </form>
    </div>
  );
};

export default AddService;
